import React, { cloneElement } from "react";
import type { FieldProps } from "@rjsf/utils";
import { spacing } from "../../../../../../../../stitches.config";
import {
  FieldPathProvider,
  useFieldPath,
} from "../../../FieldPathContext/FieldPathContext";
import {
  isFieldSelected,
  useSubmissionsBuilderContext,
} from "../../../SubmissionsBuilderContext";
import { withStopPropagation } from "../../../utils";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";
import { useFieldHasError } from "../field-error-state";
import { FieldPreviewFooter } from "../FieldPreviewFooter/FieldPreviewFooter";

type BaseFieldPreviewProps = FieldProps & {
  children: React.JSX.Element;
};

function WrappedBaseFieldPreview({ children }: BaseFieldPreviewProps) {
  const { selectField, selectedField } = useSubmissionsBuilderContext();
  const { pathArray } = useFieldPath();

  const isSelected = isFieldSelected(pathArray, selectedField);
  const hasError = useFieldHasError(pathArray);

  return (
    <BuilderFieldWrapper
      onClick={withStopPropagation(() => {
        selectField(pathArray);
      })}
      isSelected={isSelected}
      hasError={hasError}
    >
      <div style={{ marginBottom: spacing.xs.toString() }}>
        {cloneElement(children, { isSubmissionBuilder: true })}
      </div>
      <FieldPreviewFooter fieldPath={pathArray} />
    </BuilderFieldWrapper>
  );
}

export function BaseFieldPreview(props: BaseFieldPreviewProps) {
  return (
    <FieldPathProvider path={props.name}>
      <WrappedBaseFieldPreview {...props} />
    </FieldPathProvider>
  );
}
